import { render, staticRenderFns } from "./BoardReg.vue?vue&type=template&id=6829cefa&scoped=true"
import script from "./BoardReg.vue?vue&type=script&lang=js"
export * from "./BoardReg.vue?vue&type=script&lang=js"
import style0 from "./BoardReg.vue?vue&type=style&index=0&id=6829cefa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6829cefa",
  null
  
)

export default component.exports